import { Link } from '@eventbrite/eds-link';
import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';
import './HeaderLink.scss';

export interface IHeaderLinkProps {
    onHeaderClick: () => void;
    linkTo: string;
    linkText: GenericLazyString;
    linkTestid?: string;
}

const HeaderLink = ({
    onHeaderClick,
    linkTo,
    linkText,
    linkTestid,
}: IHeaderLinkProps) => {
    const handleOnClick = (event: React.SyntheticEvent) => {
        event.preventDefault();

        onHeaderClick();
    };

    return (
        <div className="auth-lib__header-link eds-text-weight--heavy eds-l-pad-left-5">
            <Link
                onClick={handleOnClick}
                type="button"
                data-testid={linkTestid}
                to={linkTo}
            >
                {linkText}
            </Link>
        </div>
    );
};

export default HeaderLink;
